export class VoipFormats {
	ClientVisible: boolean;
	FileExtension: string;
	FriendlyName: string;
	Id: number;
	ShellCommand: string;

	name: string;
}